const style = document.createElement("style");
style.innerHTML = `
  .mobile-dividend-table {
    padding-top: 1px; 
    display: block;
  }
  .desktop-dividend-table {
    display: none;
  }
  .dividend-table-tab {
    border: none;
    appearance: none;
    outline: none;
    cursor: pointer;
    padding: 10px 12px;
    font-weight: 700;
    background-color: #EBEBEB;
    color: #666666;
    border-radius: 4px;
    font-size: 16px;
  }
  .dividend-table-tab.active {
    background-color: #FFF3EE;
    color: #FF9664;
    box-shadow: 0 0 0 1px #FF9664;
  }
  #dividendPayoutPagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #dividendPayoutPagination button{
    display: flex;
    justify-content: center;
    align-items: center;
    appearance: none;
    outline: none;
    cursor: pointer;
    padding: 6px;
    border-radius: 4px;
    border: 1px solid #EBEBEB;
    background-color: #FFFFFF;  
    margin: 0px 4px 0 4px;
  }
  #dividendPayoutPagination button:disabled{
    cursor: not-allowed;
    color: #EBEBEB;
  }
  #dividendPayoutPagination select {
    width: 5rem;          /* w-20 */
    height: 38px;
    background-color: white;
    border-radius: 0.25rem;  /* rounded */
    border: 1px solid #EBEBEB;
    padding-left: 1rem;    /* px-4 */
    padding-right: 1rem;
    margin-right: 0.5rem;  /* mr-2 */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='currentColor'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;  /* bg-right-4 */
    background-size: 1.25rem;
    outline: none;
    appearance: none;
    font-size: 16px;
    cursor: pointer;
  }

  #dividendPayoutPagination select:focus {
    border-color: #3B82F6;  /* focus:border-new-blue-500 */
  }
  @media (min-width: 768px) {
    .mobile-dividend-table {
      display: none;
    }
    .desktop-dividend-table {
      display: block;
    }
  }
`;
document.head.appendChild(style);
// url參數
let scriptId = document.getElementById("fundDividendPayoutScript");

let mfxId =
  scriptId && scriptId.attributes["mfx-id"]
    ? scriptId && scriptId.attributes["mfx-id"].value
    : "ALGW";

let currentTab = 'distribution';

// 數字格式化
function NumFormatter(num, decimal) {
    this.value =
      num !== null && num !== undefined
        ? num.toLocaleString(undefined, {
            minimumFractionDigits: decimal,
            maximumFractionDigits: decimal,
          })
        : "--";
  
    this.addPercent = function () {
      this.value =
        num !== null && num !== undefined ? `${this.value}%` : this.value;
      return this;
    };
  
    this.addPrefix = function () {
      if (num > 0) this.value = `+${this.value}`;
      if (num < 0) this.value = `${this.value}`;
      return this;
    };
  }
  
  function numHandler(num, decimal = 2) {
    return new NumFormatter(num, decimal);
  }

  function formatComma(num, decimal) {
    return numHandler(num, decimal).value //122,000
}
  
  function formatPercent(num, decimal) {
    return numHandler(num, decimal).addPercent().value; // 12.55%
  }
  
  function formatReturnPercent(num, decimal) {
    return numHandler(num, decimal).addPercent().addPrefix().value; //+12.55%
  }
  
  function numTextColor(num) {
    if (num !== null && num !== undefined) {
      return num > 0
        ? "text-red-500"
        : num < 0
        ? "text-green-500"
        : "text-gray-500";
    } else {
      return "text-gray-800";
    }
  }
  
/* eslint-disable-next-line no-unused-vars */
function switchTable(table) {
    currentTab = table
    const buttons = document.querySelectorAll('.dividend-table-tab')
    buttons.forEach(button => {
        button.classList.remove('active');
        if (button.textContent === (table === 'distribution' ? '配息分配' : '含息報酬')) {
            button.classList.add('active');
        }
    })

    const distributionTable = document.getElementById('distributionTable');
    const returnTable = document.getElementById('returnTable');

    if (table === 'distribution') {
        distributionTable.style.display = 'table';
        returnTable.style.display = 'none';
    } else {
        distributionTable.style.display = 'none';
        returnTable.style.display = 'table';
    }
}

function generatePagination(currentPage = 1, totalPage = 10) {
    const pagiDiv = document.getElementById("dividendPayoutPagination");
    
    // 清空現有內容
    pagiDiv.innerHTML = '';
    
    // 創建所有元素
    const firstButton = document.createElement('button');
    const prevButton = document.createElement('button');
    const selectDiv = document.createElement('div');
    const nextButton = document.createElement('button');
    const lastButton = document.createElement('button');

    // 設置 SVG 內容
    const svgContent = {
        first: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g transform="translate(0.5,0)">
                <line x1="7" y1="6" x2="7" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M17 18L11 12L17 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
        </svg>`,
        prev: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        next: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>`,
        last: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 18L13 12L7 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="17" y1="6" x2="17" y2="18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>`
    };

    // 設置按鈕內容
    firstButton.innerHTML = svgContent.first;
    prevButton.innerHTML = svgContent.prev;
    nextButton.innerHTML = svgContent.next;
    lastButton.innerHTML = svgContent.last;

    // 創建 select 內容
    selectDiv.style.display = 'flex';
    selectDiv.style.alignItems = 'center';
    selectDiv.style.margin = '16px 8px 16px 8px';
    
    const select = document.createElement('select');
    const totalPages = Math.ceil(totalPage / 10);
   

    // 添加選項
    for (let i = 1; i <= totalPages; i++) {
        const option = document.createElement('option');
        option.value = i;
        option.textContent = i;
        select.appendChild(option);
    }

    select.value = currentPage;

    const totalPageSpan = document.createElement('div');
    totalPageSpan.textContent = `/ ${totalPages}`;
    totalPageSpan.style.marginLeft = '4px';
    totalPageSpan.style.fontSize = '16px';

    selectDiv.appendChild(select);
    selectDiv.appendChild(totalPageSpan);

    // 按照指定順序添加所有元素
    pagiDiv.append(firstButton, prevButton, selectDiv, nextButton, lastButton);

    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;
    // 設置按鈕禁用狀態
    firstButton.disabled = isFirstPage;
    prevButton.disabled = isFirstPage;
    nextButton.disabled = isLastPage;
    lastButton.disabled = isLastPage;

    // 添加按鈕點擊事件
    firstButton.addEventListener('click', async () => {
        if (!isFirstPage) {
            const data = await fetchDividendHistory(1);
            if (data) {
                renderDividendTable(data);
            }
        }
    });

    prevButton.addEventListener('click', async () => {
        if (!isFirstPage) {
            const data = await fetchDividendHistory(currentPage - 1);
            if (data) {
                renderDividendTable(data);
            }
        }
    });

    nextButton.addEventListener('click', async () => {
        if (!isLastPage) {
            const data = await fetchDividendHistory(currentPage + 1);
            if (data) {
                renderDividendTable(data);
            }
        }
    });

    lastButton.addEventListener('click', async () => {
        if (!isLastPage) {
            const data = await fetchDividendHistory(totalPages);
            if (data) {
                renderDividendTable(data);
            }
        }
    });

    select.addEventListener('change', async function() {
        const data = await fetchDividendHistory(parseInt(this.value));
        if (data) {
            renderDividendTable(data);
        }
    });
}

// API 請求函數
async function fetchDividendHistory(page = 1, size = 10) {
    try {
        const url = `https://${window.location.host}/next/api/funds/detail/${mfxId}/dividend-history?page=${page}&size=${size}`;
        const response = await fetch(url);
        
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        
        return await response.json();
    } catch (error) {
        console.error("發生錯誤:", error);
        return null;
    }
}

// 渲染畫面函數
function renderDividendTable(data) {
    if (!data) return;

    const oldContent = document.querySelector('.dividend-payout-container');
    if (oldContent) {
        oldContent.remove();
    }

    const targetElement = document.getElementById("fundDividendPayoutScript");
    const dividendPayoutInfo = document.createElement("div");
    dividendPayoutInfo.className = "dividend-payout-container";
    
    dividendPayoutInfo.innerHTML = `
        <div>
            <div>
                <div class="mobile-dividend-table">
                    <button class="dividend-table-tab ${currentTab === 'distribution' ? 'active' : ''}">配息分配</button>
                    <button style="margin-left: 8px; margin-bottom: 10px" class="dividend-table-tab ${currentTab === 'return' ? 'active' : ''}">含息報酬</button>
                    <table id="distributionTable" style="width: 100%; table-layout: fixed; border-collapse: separate; border-spacing: 0; border: 1px solid #F5F5F5; border-radius: 4px;">
                        <thead style="background-color: #E0E0E0;">
                            <tr style="font-size: 14px; color: #363636;">
                                <th style="padding: 8px 8px; border-top-left-radius: 4px;">除息日</th>
                                <th style="padding: 8px 8px;">基準日</th>
                                <th style="text-align: right; padding: 8px 8px;">每單位分配</th>
                                <th style="text-align: right; padding: 8px 8px; border-top-right-radius: 4px;">當期配息</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.items.map((item, index) => `
                                <tr style="font-size: 14px; color: #666666; ${index % 2 === 1 ? 'background-color: #F5F5F5;' : ''}">
                                    <td style="text-align: center; padding: 8px 8px;">${item.date || '--'}</td>
                                    <td style="text-align: center; padding: 8px 8px;">${item.baseDate || '--'}</td>
                                    <td style="text-align: right; padding: 8px 8px;">${formatComma(item.dividend, 6)}</td>
                                    <td style="text-align: right; padding: 8px 8px;">${formatPercent(item.divYield * 100)}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                    <table id="returnTable" style="display: none; width: 100%; table-layout: fixed; border-collapse: separate; border-spacing: 0; border: 1px solid #F5F5F5; border-radius: 4px;">
                        <thead style="background-color: #E0E0E0;">
                            <tr style="font-size: 14px; color: #363636;">
                                <th style="padding: 8px 8px; border-top-left-radius: 4px;">除息日</th>
                                <th style="padding: 8px 8px;">發放日</th>
                                <th style="text-align: right; padding: 8px 8px;">總報酬(含息)</th>
                                <th style="text-align: right; padding: 8px 8px; border-top-right-radius: 4px;">總報酬(不含息)</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.items.map((item, index) => `
                                <tr style="font-size: 14px; color: #666666; ${index % 2 === 1 ? 'background-color: #F5F5F5;' : ''}">
                                    <td style="text-align: center; padding: 8px 8px;">${item.date || '--'}</td>
                                    <td style="text-align: center; padding: 8px 8px;">${item.distributeDate || '--'}</td>
                                    <td style="text-align: right; padding: 8px 8px; font-weight: 500;" class="${numTextColor(item.currentDivProfit)}">
                                        ${formatReturnPercent(item.currentDivProfit * 100)}
                                    </td>
                                    <td style="text-align: right; padding: 8px 8px; font-weight: 500;" class="${numTextColor(item.currentRoi)}">
                                        ${formatReturnPercent(item.currentRoi * 100)}
                                    </td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                    <div style="font-size: 14px; margin-top: 16px; background: #f5f5f5; padding: 16px; border-radius: 4px;">資料來源：好好證券彙整，詳見重要聲明。</div>
                </div>

                <div class="desktop-dividend-table">
                    <table style="width: 100%; border-collapse: separate; border-spacing: 0; border: 1px solid #F5F5F5; border-radius: 4px;">
                        <thead style="background-color: #E0E0E0;">
                            <tr style="font-size: 14px; color: #363636;">
                                <th style="text-align: left; padding: 8px 8px; width: 14%; border-top-left-radius: 4px;">除息日</th>
                                <th style="text-align: left; padding: 8px 8px; width: 12%;">基準日</th>
                                <th style="text-align: right; padding: 8px 8px; width: 12%;">發放日</th>
                                <th style="text-align: right; padding: 8px 8px; width: 14%;">每單位分配</th>
                                <th style="text-align: right; padding: 8px 8px; width: 14%;">當期配息</th>
                                <th style="text-align: right; padding: 8px 8px; width: 16%;">當期報酬(含息)</th>
                                <th style="text-align: right; padding: 8px 8px; width: 18%; border-top-right-radius: 4px;">當期報酬(不含息)</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data.items.map((item, index) => `
                                <tr style="font-size: 16px; color: #666666; ${index % 2 === 1 ? 'background-color: #F5F5F5;' : ''}">
                                    <td style="text-align: left; padding: 8px 8px;">${item.date || '--'}</td>
                                    <td style="text-align: left; padding: 8px 8px;">${item.baseDate || '--'}</td>
                                    <td style="text-align: right; padding: 8px 8px;">${item.distributeDate || '--'}</td>
                                    <td style="text-align: right; padding: 8px 8px;">${formatComma(item.dividend, 6)}</td>
                                    <td style="text-align: right; padding: 8px 8px;">${formatPercent(item.divYield * 100)}</td>
                                    <td style="text-align: right; padding: 8px 8px;" class="${numTextColor(item.currentDivProfit)}">
                                        ${formatReturnPercent(item.currentDivProfit * 100)}
                                    </td>
                                    <td style="text-align: right; padding: 8px 8px;" class="${numTextColor(item.currentRoi)}">
                                        ${formatReturnPercent(item.currentRoi * 100)}
                                    </td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                    <div style="font-size: 14px; margin-top: 16px; background: #f5f5f5; padding: 16px; border-radius: 4px;">資料來源：好好證券彙整，詳見重要聲明。</div>
                </div>
            </div>
            
            <div id="dividendPayoutPagination"></div>
        </div>
    `;

    targetElement.innerHTML = '';
    targetElement.appendChild(dividendPayoutInfo);
    generatePagination(data.page, data.total);

    const buttons = document.querySelectorAll('.dividend-table-tab')
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            switchTable(button.textContent === '配息分配' ? 'distribution' : 'return');
        })
    })

    const distributionTable = document.getElementById('distributionTable');
    const returnTable = document.getElementById('returnTable');
    
    if (currentTab === 'distribution') {
        distributionTable.style.display = 'table';
        returnTable.style.display = 'none';
    } else {
        distributionTable.style.display = 'none';
        returnTable.style.display = 'table';
    }
}

// 初始化函數
async function loadScript() {
    const data = await fetchDividendHistory();
    if (data) {
        renderDividendTable(data);
    }
}

loadScript();  